import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CarTilesCarousel } from '../../../../components/carousels/car-tiles/CarTilesCarousel/CarTilesCarousel';
import { IVehicleTile } from '../../../../types/vehicleTile';
import { removeViewedVehicleItemLocalStorage } from '../../utilities/viewedVehiclesTileBuilder';
import useAppState from '../../../../common/state/appState';
import { CarouselButtons } from '../../../../components/CarouselButtons';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../../../utilities/analytics';
import { useEffect } from 'react';

const ViewedVehiclesCarousel = () => {
    const isLoading = useAppState((state) => state.isLoading);
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const removeRecentlyViewedVehicle = useAppState((state) => state.removeRecentlyViewedVehicle);

    const onRemove = (vehicle: IVehicleTile) => {
        const { stockNumber } = vehicle;

        removeRecentlyViewedVehicle(stockNumber);

        removeViewedVehicleItemLocalStorage(vehicle);
    };

    const fireImpressionTagOnlyWhenRendered = () => {
        trackEDDL({
            event: ANALYTICS_CONSTANTS.EVENTS.IMPRESSION.VIEWED_VEHICLES,
            recommendations: {
                stockNumber: '',
                similarVehicles: recentlyViewedVehicles.map((vehicle) => vehicle.stockNumber).join(','),
                carouselLength: String(recentlyViewedVehicles.length),
            },
            module: {
                moduleExperience: 'VR|Homepage|You looked at',
            },
        });
    };

    useEffect(() => {
        if (!isLoading && recentlyViewedVehicles.length > 0) {
            fireImpressionTagOnlyWhenRendered();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, recentlyViewedVehicles]);

    if (isLoading || recentlyViewedVehicles.length === 0) {
        return <></>;
    }

    return (
        <Stack spacing={2} sx={{ mt: 4 }}>
            <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                <Typography component="h2" variant="h4">
                    You looked at
                </Typography>
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <CarouselButtons sectionIdPrefix="viewed-vehicles" ariaText="You looked at" />
                </Box>
            </Stack>
            <Box
                sx={(theme) => ({
                    [theme.breakpoints.up('sm')]: {
                        ['#viewed-vehicles-carousel-slides .tns-item']: { paddingRight: '1rem' },
                    },
                    ['.tns-ovh']: {
                        minHeight: '367px !important',
                        height: 'unset !important',
                    },
                    ['.carousel-slides__centered ']: {
                        textAlign: 'left',
                    },
                })}
            >
                <CarTilesCarousel
                    carouselId="viewed-vehicles"
                    vehiclesData={recentlyViewedVehicles}
                    placeholder={{ cardText: 'Nothing feeling quite right?', buttonText: 'Browse for cars' }}
                    onRemove={onRemove}
                    isRemoveEnabled
                    sectionName="You looked at"
                    nextFocus="personal-finance-component"
                />
            </Box>
        </Stack>
    );
};

export default ViewedVehiclesCarousel;
